import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return next(req);
  }

  const localStorageService = inject(LocalStorageService);
  const headers: Record<string, string> = {};

  const token = localStorageService.get('sToken');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // `ocpApimSubscriptionKey` tem precedência (override explícito do gateway);
  // na ausência dele cai para `subscriptionKeyPortalVivestCenter` — a mesma chave
  // que o PerfilService já envia —, de modo que toda chamada autenticada use a
  // chave do portal por padrão (ex.: env development, onde `ocpApimSubscriptionKey`
  // não é definido).
  const subscriptionKey =
    environment.ocpApimSubscriptionKey?.trim() ||
    environment.subscriptionKeyPortalVivestCenter?.trim();
  if (subscriptionKey) {
    headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
  }

  if (Object.keys(headers).length === 0) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: headers,
    }),
  );
};
